import { Pipe, PipeTransform } from '@angular/core';
import { Functionality } from '../../classes/auth/functionality';
import { Role } from '../../classes/auth/role.class';

@Pipe({
    name: 'roleHasFunctionality',
    standalone: false,
})
export class RoleHasFunctionalityPipe implements PipeTransform {
    transform(role: Role, functionality: Functionality, ...args: unknown[]): boolean {
        return !!role.functionalities.find(f => f.key === functionality.key);
    }
}
